import { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Solutions from './pages/Solutions';
import Industries from './pages/Industries';
import Contact from './pages/Contact';
import Mitra from './pages/Mitra';
import Admin from './pages/Admin';
import Onboarding from './pages/Onboarding';
import ReceiptPortal from './pages/ReceiptPortal';

const NAV_HIDE_ELS = '.ind-nav, .sol-nav, .about-nav, .contact-nav';
const TEXT_SIDES = '.about-text-side, .sol-text-side, .ind-text-side';

function MainSite() {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Sub-navs: hide during scroll, show after snap
    let timer = null;
    const hideNavs = () => {
      container.querySelectorAll(NAV_HIDE_ELS).forEach(el => { el.style.opacity = '0'; });
      clearTimeout(timer);
      timer = setTimeout(() => {
        container.querySelectorAll(NAV_HIDE_ELS).forEach(el => { el.style.opacity = '1'; });
      }, 50);
    };
    container.addEventListener('scroll', hideNavs, { passive: true });

    // Right-side text: show instantly when section is fully snapped
    container.querySelectorAll(TEXT_SIDES).forEach(el => { el.style.opacity = '0'; });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          const textSide = entry.target.querySelector(TEXT_SIDES);
          if (textSide) textSide.style.opacity = entry.intersectionRatio >= 0.98 ? '1' : '0';
        });
      },
      { root: container, threshold: [0.98, 1.0] }
    );

    ['about', 'solutions', 'industries'].forEach(id => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => {
      container.removeEventListener('scroll', hideNavs);
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App scroll-container" ref={containerRef}>
        <Navbar />
        <section id="home"><Home /></section>
        <section id="about"><About /></section>
        <section id="solutions"><Solutions /></section>
        <section id="industries"><Industries /></section>
        <section id="contact"><Contact /></section>
      </div>
    </LanguageProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route path="/mitra" element={<Mitra />} />
        <Route path="/onboarding/:token" element={<Onboarding />} />
        <Route path="/receipt/:token" element={<ReceiptPortal />} />
        <Route path="*" element={<MainSite />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
